// Mock data for SVF Foundation site

export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'SVIH', to: '/svih' },
  { label: 'SVVS', to: '/svvs' },
  { label: 'SVLC', to: '/svlc' },
  { label: 'Gallery', to: '/gallery' },
];

export const wings = [
  {
    code: 'SVLC',
    title: 'School of Vedic Linguistics and Classical Languages',
    short: 'An Indic Linguistic Institute preserving and propagating Indic languages threatened by globalization.',
    to: '/svlc',
    hero: 'Preserving the Sacred Voices of Bharata',
    description: 'SVLC is dedicated to the study, preservation, and revival of Indic languages \u2014 from Sanskrit and Pali to Prakrits, Tamil, Telugu, Kannada, and the many regional and tribal tongues that carry our civilizational memory. Through rigorous philology, computational linguistics, and pedagogy, we ensure these languages continue to live, breathe, and inspire.',
    focus: [
      'Classical Sanskrit grammar, etymology, and prosody',
      'Comparative Indic linguistics and historical phonology',
      'Digital corpora of palm-leaf and manuscript traditions',
      'Spoken Sanskrit and immersive language pedagogy',
      'Endangered tribal and regional Indic languages',
    ],
  },
  {
    code: 'SVIH',
    title: 'School of Vedic Intellectual Heritage',
    short: 'An Indic History, Culture, and Philosophy Institute studying Indic history, philosophy, and civilization.',
    to: '/svih',
    hero: 'Reclaiming the Civilizational Memory of Bharata',
    description: 'SVIH studies the long arc of Indic civilization \u2014 its philosophies, sciences, arts, and history \u2014 through indigenous frames of reference. We engage with the Darshanas, the Itihasa-Purana corpus, Buddhist and Jain thought, and the lived intellectual traditions of Bharata to articulate a Vedic worldview for the present.',
    focus: [
      'The six Darshanas and Indic philosophical schools',
      'Itihasa, Purana, and the historicity of Indic narrative',
      'Indic sciences: Jyotisha, Ayurveda, Vastu, Ganita',
      'Aesthetics: Natyashastra, Rasa theory, and Indic arts',
      'Decolonial historiography and civilizational studies',
    ],
  },
  {
    code: 'SVVS',
    title: 'School of Vedic and Vidya Studies',
    short: 'An Institute of Vedic Research dedicated to preservation and promotion of Vedic wisdom and Sanskrit.',
    to: '/svvs',
    hero: 'At the Source: The Eternal Veda',
    description: 'SVVS is the heart of the foundation \u2014 a center for the recitation, interpretation, and contemplative study of the four Vedas, their Brahmanas, Aranyakas, and Upanishads. We bring together traditional Pathashala scholarship and contemporary research to keep the Shruti tradition living and luminous.',
    focus: [
      'Rigveda, Yajurveda, Samaveda, Atharvaveda recitation',
      'Vedic phonetics, accents, and oral transmission',
      'Upanishadic philosophy and contemplative inquiry',
      'Brahmana and Aranyaka textual studies',
      'Vedic mathematics, geometry, and ritual sciences',
    ],
  },
];

export const aboutSections = [
  {
    title: 'Legacy',
    body: 'The Foundation stands as a continuation of the ideals lived by Sri Sagi Venkata Narasimham — a quiet life devoted to knowledge, Sanskrit, Vedic learning, Spiritual Sadhaka and selfless service. Rather than preserving a memory, SVF seeks to continue a living tradition, carrying his values forward through scholarship, education, and the preservation of civilizational heritage of Bharat.',
  },
  {
    title: 'Our Vision',
    body: 'A Global India proud of its Vedic roots \u2014 confident in its civilizational identity, generous in its dialogue with the world, and rooted in the timeless wisdom of the Rishis. We see Bharata not as a relic of the past but as a living wellspring of insight for humanity\u2019s shared future.',
  },
  {
    title: 'Our Mission',
    body: 'To preserve, research, and propagate Indic cultures, languages, philosophy, and identity whose existence are threatened by globalization. Through rigorous scholarship, accessible education, and community engagement, we ensure that the profound wisdom of the Vedas and Indic civilization remains vibrant and relevant for future generations.',
  },
  {
    title: 'Our Approach',
    body: 'We bridge the traditional Pathashala and the modern university. We honour the Guru-Shishya parampara while engaging the methods of contemporary scholarship. Every initiative \u2014 from manuscript preservation to digital pedagogy \u2014 is shaped by the conviction that knowledge serves dharma.',
  },
  
];

export const galleryItems = [
  { src: 'https://images.unsplash.com/photo-1514222134-b57cbb8ce073?w=900&q=80', caption: 'Golden Temple at twilight' },
  { src: 'https://images.unsplash.com/photo-1643300788512-64b38ad876c6?w=900&q=80', caption: 'Ancient manuscript study' },
  { src: 'https://images.pexels.com/photos/35877137/pexels-photo-35877137.jpeg?w=900&q=80', caption: 'Saraswati \u2014 Goddess of Vidya' },
  { src: 'https://images.unsplash.com/photo-1419640303358-44f0d27f48e7?w=900&q=80', caption: 'Lamp upon the sacred text' },
  { src: 'https://images.pexels.com/photos/15235034/pexels-photo-15235034.jpeg?w=900&q=80', caption: 'Palm-leaf manuscripts' },
  { src: 'https://images.pexels.com/photos/18275890/pexels-photo-18275890.jpeg?w=900&q=80', caption: 'Sanctum of Light' },
  { src: 'https://images.pexels.com/photos/32118193/pexels-photo-32118193.jpeg?w=900&q=80', caption: 'Temple interior, ornate' },
  { src: 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?w=900&q=80', caption: 'Vedic ritual fire' },
];

export const heroImage = 'https://customer-assets.emergentagent.com/job_gold-clarity/artifacts/waudzur3_svf-hero-vedic-library-om-visible.png';

export const logos = {
  indigo: 'https://customer-assets.emergentagent.com/job_gold-clarity/artifacts/z165xgzo_SVF_Logo_Authentic_Manuscript.png',
  maroon: 'https://customer-assets.emergentagent.com/job_gold-clarity/artifacts/xgdzbvs0_SVF_Logo_Maroon.png',
  gold: 'https://customer-assets.emergentagent.com/job_gold-clarity/artifacts/72u7q9ug_SVF_Logo_Gold_Authentic_Manuscript.png',
};
